import type { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import type { QueryClient } from '@tanstack/react-query';
import { clearPermissions } from '@/redux/permissionsSlice';

export const PERMISSIONS_QUERY_KEY = ['permissions', 'me'] as const;

export const clearPermissionsSession = (
  dispatch: Dispatch<UnknownAction>,
  queryClient: QueryClient,
  sessionKey?: string
): void => {
  dispatch(clearPermissions());
  queryClient.removeQueries({
    queryKey: sessionKey ? [...PERMISSIONS_QUERY_KEY, sessionKey] : [...PERMISSIONS_QUERY_KEY],
  });
};
